'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Image$PvpcontrollerWeb = require("./Image.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Changelog$PvpcontrollerWeb = require("./Changelog.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var MobileDetect$PvpcontrollerWeb = require("../MobileDetect.js");
var EditableValue$PvpcontrollerWeb = require("./EditableValue.js");
var ArmorPieceService$PvpcontrollerWeb = require("../services/ArmorPieceService.js");

var baseContent_0 = Css.display("flex");

var baseContent_1 = {
  hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
  tl: {
    hd: Css.padding(Css.px(30)),
    tl: /* [] */0
  }
};

var baseContent = {
  hd: baseContent_0,
  tl: baseContent_1
};

var content = Curry._1(Css.style, {
      hd: Css.height(Css.px(190)),
      tl: baseContent
    });

var baseContentLoading_0 = Css.display("flex");

var baseContentLoading_1 = {
  hd: Css.backgroundColor(Css.hex("34373c")),
  tl: {
    hd: Css.padding(Css.px(30)),
    tl: /* [] */0
  }
};

var baseContentLoading = {
  hd: baseContentLoading_0,
  tl: baseContentLoading_1
};

var contentLoading = Curry._1(Css.style, {
      hd: Css.height(Css.px(190)),
      tl: baseContentLoading
    });

var leftPanel = Curry._1(Css.style, {
      hd: Css.minWidth(Css.px(200)),
      tl: /* [] */0
    });

var image = Curry._1(Css.style, {
      hd: Css.width(Css.px(50)),
      tl: {
        hd: Css.marginTop(Css.px(20)),
        tl: {
          hd: Css.marginLeft(Css.px(30)),
          tl: /* [] */0
        }
      }
    });

var name = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(25)),
      tl: {
        hd: Css.color(Css.hex("78a4ec")),
        tl: /* [] */0
      }
    });

var rightPanel = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent(Css.spaceEvenly),
        tl: {
          hd: Css.flexGrow(1.0),
          tl: {
            hd: Css.marginTop(Css.px(40)),
            tl: {
              hd: Css.marginRight(Css.px(50)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var infoGroup = Curry._1(Css.style, /* [] */0);

var statEntry = Curry._1(Css.style, {
      hd: Css.marginBottom(Css.px(10)),
      tl: /* [] */0
    });

var content$1 = Curry._1(Css.style, {
      hd: Css.flexDirection(Css.column),
      tl: baseContent
    });

var contentLoading$1 = Curry._1(Css.style, {
      hd: Css.height(Css.rem(25.7)),
      tl: baseContentLoading
    });

var rightPanel$1 = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexWrap(Css.wrap),
        tl: {
          hd: Css.justifyContent(Css.spaceBetween),
          tl: {
            hd: Css.flexGrow(1.0),
            tl: {
              hd: Css.marginTop(Css.px(40)),
              tl: {
                hd: Css.marginRight(Css.px(50)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var infoGroup$1 = Curry._1(Css.style, {
      hd: Css.padding2(Css.zero, Css.rem(0.5)),
      tl: /* [] */0
    });

function armorPieceDetails(armorPiece, editMode, setState, session, setChangelogState) {
  var defense = String(armorPiece.currentDefense);
  var meleeDamagePercentage = String(armorPiece.currentMeleeDamagePercentage);
  var magicDamagePercentage = String(armorPiece.currentMagicDamagePercentage);
  var rangedDamagePercentage = String(armorPiece.currentRangedDamagePercentage);
  var minionDamagePercentage = String(armorPiece.currentMinionDamagePercentage);
  return React.createElement("div", {
              className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? content$1 : content
            }, React.createElement("div", {
                  className: leftPanel
                }, React.createElement("div", {
                      className: name
                    }, armorPiece.name), React.createElement(Image$PvpcontrollerWeb.make, Image$PvpcontrollerWeb.makeProps(armorPiece.image, image, undefined, undefined, undefined, undefined))), React.createElement("div", {
                  className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? rightPanel$1 : rightPanel
                }, React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, armorPiece, session, editMode, "Melee Damage Bonus", meleeDamagePercentage + "%", (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                var percentage = value === "vanilla" ? (
                                    state ? state._0.baseMeleeDamagePercentage : undefined
                                  ) : Belt_Int.fromString(value.replace("%", ""));
                                if (!state) {
                                  return ;
                                }
                                if (percentage === undefined) {
                                  return ;
                                }
                                var armorPiece = state._0;
                                if (percentage !== armorPiece.currentMeleeDamagePercentage) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState[1], (function (_previousState) {
                                              return /* ArmorPiece */{
                                                      _0: {
                                                        name: armorPiece.name,
                                                        image: armorPiece.image,
                                                        netId: armorPiece.netId,
                                                        baseDefense: armorPiece.baseDefense,
                                                        currentDefense: armorPiece.currentDefense,
                                                        baseMeleeDamagePercentage: armorPiece.baseMeleeDamagePercentage,
                                                        baseMagicDamagePercentage: armorPiece.baseMagicDamagePercentage,
                                                        baseRangedDamagePercentage: armorPiece.baseRangedDamagePercentage,
                                                        baseMinionDamagePercentage: armorPiece.baseMinionDamagePercentage,
                                                        currentMeleeDamagePercentage: percentage,
                                                        currentMagicDamagePercentage: armorPiece.currentMagicDamagePercentage,
                                                        currentRangedDamagePercentage: armorPiece.currentRangedDamagePercentage,
                                                        currentMinionDamagePercentage: armorPiece.currentMinionDamagePercentage
                                                      }
                                                    };
                                            }));
                              }), ArmorPieceService$PvpcontrollerWeb.updateArmorPieceMeleeDamagePercentage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)), React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, armorPiece, session, editMode, "Magic Damage Bonus", magicDamagePercentage + "%", (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                var percentage = value === "vanilla" ? (
                                    state ? state._0.baseMagicDamagePercentage : undefined
                                  ) : Belt_Int.fromString(value.replace("%", ""));
                                if (!state) {
                                  return ;
                                }
                                if (percentage === undefined) {
                                  return ;
                                }
                                var armorPiece = state._0;
                                if (percentage !== armorPiece.currentMagicDamagePercentage) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState[1], (function (_previousState) {
                                              return /* ArmorPiece */{
                                                      _0: {
                                                        name: armorPiece.name,
                                                        image: armorPiece.image,
                                                        netId: armorPiece.netId,
                                                        baseDefense: armorPiece.baseDefense,
                                                        currentDefense: armorPiece.currentDefense,
                                                        baseMeleeDamagePercentage: armorPiece.baseMeleeDamagePercentage,
                                                        baseMagicDamagePercentage: armorPiece.baseMagicDamagePercentage,
                                                        baseRangedDamagePercentage: armorPiece.baseRangedDamagePercentage,
                                                        baseMinionDamagePercentage: armorPiece.baseMinionDamagePercentage,
                                                        currentMeleeDamagePercentage: armorPiece.currentMeleeDamagePercentage,
                                                        currentMagicDamagePercentage: percentage,
                                                        currentRangedDamagePercentage: armorPiece.currentRangedDamagePercentage,
                                                        currentMinionDamagePercentage: armorPiece.currentMinionDamagePercentage
                                                      }
                                                    };
                                            }));
                              }), ArmorPieceService$PvpcontrollerWeb.updateArmorPieceMagicDamagePercentage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined))), React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, armorPiece, session, editMode, "Ranged Damage Bonus", rangedDamagePercentage + "%", (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                var percentage = value === "vanilla" ? (
                                    state ? state._0.baseRangedDamagePercentage : undefined
                                  ) : Belt_Int.fromString(value.replace("%", ""));
                                if (!state) {
                                  return ;
                                }
                                if (percentage === undefined) {
                                  return ;
                                }
                                var armorPiece = state._0;
                                if (percentage !== armorPiece.currentRangedDamagePercentage) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState[1], (function (_previousState) {
                                              return /* ArmorPiece */{
                                                      _0: {
                                                        name: armorPiece.name,
                                                        image: armorPiece.image,
                                                        netId: armorPiece.netId,
                                                        baseDefense: armorPiece.baseDefense,
                                                        currentDefense: armorPiece.currentDefense,
                                                        baseMeleeDamagePercentage: armorPiece.baseMeleeDamagePercentage,
                                                        baseMagicDamagePercentage: armorPiece.baseMagicDamagePercentage,
                                                        baseRangedDamagePercentage: armorPiece.baseRangedDamagePercentage,
                                                        baseMinionDamagePercentage: armorPiece.baseMinionDamagePercentage,
                                                        currentMeleeDamagePercentage: armorPiece.currentMeleeDamagePercentage,
                                                        currentMagicDamagePercentage: armorPiece.currentMagicDamagePercentage,
                                                        currentRangedDamagePercentage: percentage,
                                                        currentMinionDamagePercentage: armorPiece.currentMinionDamagePercentage
                                                      }
                                                    };
                                            }));
                              }), ArmorPieceService$PvpcontrollerWeb.updateArmorPieceRangedDamagePercentage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)), React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, armorPiece, session, editMode, "Minion Damage Bonus", minionDamagePercentage + "%", (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                var percentage = value === "vanilla" ? (
                                    state ? state._0.baseMinionDamagePercentage : undefined
                                  ) : Belt_Int.fromString(value.replace("%", ""));
                                if (!state) {
                                  return ;
                                }
                                if (percentage === undefined) {
                                  return ;
                                }
                                var armorPiece = state._0;
                                if (percentage !== armorPiece.currentMinionDamagePercentage) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState[1], (function (_previousState) {
                                              return /* ArmorPiece */{
                                                      _0: {
                                                        name: armorPiece.name,
                                                        image: armorPiece.image,
                                                        netId: armorPiece.netId,
                                                        baseDefense: armorPiece.baseDefense,
                                                        currentDefense: armorPiece.currentDefense,
                                                        baseMeleeDamagePercentage: armorPiece.baseMeleeDamagePercentage,
                                                        baseMagicDamagePercentage: armorPiece.baseMagicDamagePercentage,
                                                        baseRangedDamagePercentage: armorPiece.baseRangedDamagePercentage,
                                                        baseMinionDamagePercentage: armorPiece.baseMinionDamagePercentage,
                                                        currentMeleeDamagePercentage: armorPiece.currentMeleeDamagePercentage,
                                                        currentMagicDamagePercentage: armorPiece.currentMagicDamagePercentage,
                                                        currentRangedDamagePercentage: armorPiece.currentRangedDamagePercentage,
                                                        currentMinionDamagePercentage: percentage
                                                      }
                                                    };
                                            }));
                              }), ArmorPieceService$PvpcontrollerWeb.updateArmorPieceMinionDamagePercentage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined))), React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, armorPiece, session, editMode, "Defense", defense, (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                var defense = value === "vanilla" ? (
                                    state ? state._0.baseDefense : undefined
                                  ) : Belt_Int.fromString(value);
                                if (!state) {
                                  return ;
                                }
                                if (defense === undefined) {
                                  return ;
                                }
                                var armorPiece = state._0;
                                if (defense !== armorPiece.currentDefense) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState[1], (function (_previousState) {
                                              return /* ArmorPiece */{
                                                      _0: {
                                                        name: armorPiece.name,
                                                        image: armorPiece.image,
                                                        netId: armorPiece.netId,
                                                        baseDefense: armorPiece.baseDefense,
                                                        currentDefense: defense,
                                                        baseMeleeDamagePercentage: armorPiece.baseMeleeDamagePercentage,
                                                        baseMagicDamagePercentage: armorPiece.baseMagicDamagePercentage,
                                                        baseRangedDamagePercentage: armorPiece.baseRangedDamagePercentage,
                                                        baseMinionDamagePercentage: armorPiece.baseMinionDamagePercentage,
                                                        currentMeleeDamagePercentage: armorPiece.currentMeleeDamagePercentage,
                                                        currentMagicDamagePercentage: armorPiece.currentMagicDamagePercentage,
                                                        currentRangedDamagePercentage: armorPiece.currentRangedDamagePercentage,
                                                        currentMinionDamagePercentage: armorPiece.currentMinionDamagePercentage
                                                      }
                                                    };
                                            }));
                              }), ArmorPieceService$PvpcontrollerWeb.updateArmorPieceDefense, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)))));
}

function ArmorPiece(Props) {
  var id = Props.id;
  var editMode = Props.editMode;
  var session = Props.session;
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* Loading */0;
      });
  var setChangelogState = match$1[1];
  React.useEffect((function () {
          return ArmorPieceService$PvpcontrollerWeb.getArmorPiece(id, (function (armorPiece) {
                        if (armorPiece.TAG === /* Ok */0) {
                          var armorPiece$1 = armorPiece._0;
                          return Curry._1(setState, (function (_previousState) {
                                        return /* ArmorPiece */{
                                                _0: armorPiece$1
                                              };
                                      }));
                        }
                        var err = armorPiece._0;
                        if (err.RE_EXN_ID !== "Match_failure") {
                          return Debugging$PvpcontrollerWeb.messageWithData("ArmorPiece-PvpcontrollerWeb:getArmorPiece Could not get armor piece.", {
                                      tags: (function (prim) {
                                          return {};
                                        }),
                                      extra: err
                                    });
                        }
                        var match = err._1;
                        return Debugging$PvpcontrollerWeb.messageWithData("ArmorPiece-PvpcontrollerWeb" + (":getArmorPiece Could not destructure armor piece. Failed at " + match[0] + ":L" + match[1].toString() + "_C" + match[2].toString()), {
                                    tags: (function (prim) {
                                        return {};
                                      }),
                                    extra: err
                                  });
                      }));
        }), []);
  return React.createElement("div", {
              className: Theme$PvpcontrollerWeb.limitedWidthCard
            }, React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Armor Piece Details"), state ? armorPieceDetails(state._0, editMode, [
                    state,
                    setState
                  ], session, setChangelogState) : React.createElement("div", {
                    className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? contentLoading$1 : contentLoading
                  }, React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))), React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Changelog"), React.createElement(Changelog$PvpcontrollerWeb.make, Changelog$PvpcontrollerWeb.makeProps((function (param, param$1, param$2) {
                        return ArmorPieceService$PvpcontrollerWeb.getArmorPieceChangelog(id, param, param$1, param$2);
                      }), true, match$1[0], setChangelogState, undefined, undefined, undefined, undefined, undefined)));
}

function makeProps(prim0, prim1, prim2, prim3, prim4) {
  var tmp = {
    id: prim0,
    editMode: prim1,
    session: prim2
  };
  if (prim3 !== undefined) {
    tmp.key = prim3;
  }
  return tmp;
}

var make = ArmorPiece;

exports.makeProps = makeProps;
exports.make = make;
/* baseContent Not a pure module */
